import React from 'react';
import { CreditCard, Calendar, PlusCircle, TrendingUp } from 'lucide-react';

/**
 * Компонент секции базовых параметров инвестиций
 */
const BasicParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Начальная сумма инвестиций */}
      <div>
        <label htmlFor="initialInvestment" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <CreditCard className="w-4 h-4 mr-2 text-indigo-500" />
          Начальная сумма инвестиций
        </label>
        <div className="relative">
          <input
            type="text"
            id="initialInvestment"
            name="initialInvestment"
            value={formData.initialInvestment}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.initialInvestment ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          <span className="absolute inset-y-0 right-3 flex items-center text-gray-500 pointer-events-none">
            ₽
          </span>
        </div>
        {errors.initialInvestment && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.initialInvestment}
          </p>
        )}
      </div>

      {/* Ежемесячное пополнение */}
      <div>
        <label htmlFor="monthlyContribution" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <PlusCircle className="w-4 h-4 mr-2 text-indigo-500" />
          Ежемесячное пополнение
        </label>
        <div className="relative">
          <input
            type="text"
            id="monthlyContribution"
            name="monthlyContribution"
            value={formData.monthlyContribution}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.monthlyContribution ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          <span className="absolute inset-y-0 right-3 flex items-center text-gray-500 pointer-events-none">
            ₽
          </span>
        </div>
        {errors.monthlyContribution && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.monthlyContribution}
          </p>
        )}
      </div>

      {/* Срок инвестирования */}
      <div>
        <label htmlFor="investmentTerm" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Calendar className="w-4 h-4 mr-2 text-indigo-500" />
          Срок инвестирования (лет)
        </label>
        <input
          type="text"
          id="investmentTerm"
          name="investmentTerm"
          value={formData.investmentTerm}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.investmentTerm ? 'input-error' : ''}`}
          placeholder="Введите срок"
        />
        {errors.investmentTerm && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.investmentTerm}
          </p>
        )}
      </div>

      {/* Дата начала инвестирования */}
      <div>
        <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Calendar className="w-4 h-4 mr-2 text-indigo-500" />
          Дата начала инвестирования
        </label>
        <input
          type="date"
          id="startDate"
          name="startDate"
          value={formData.startDate}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.startDate ? 'input-error' : ''}`}
        />
        {errors.startDate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.startDate}
          </p>
        )}
      </div>

      {/* Информационный блок */}
      <div className="col-span-full mt-2">
        <div className="p-4 bg-indigo-50 dark:bg-indigo-900/20 rounded-lg border border-indigo-100 dark:border-indigo-800">
          <div className="flex items-start">
            <TrendingUp className="w-5 h-5 text-indigo-600 dark:text-indigo-400 mt-0.5 mr-3 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-indigo-700 dark:text-indigo-300">
                Важность регулярных инвестиций
              </h4>
              <p className="text-xs text-indigo-600 dark:text-indigo-400 mt-1">
                Регулярные инвестиции и реинвестирование доходов позволяют использовать силу сложного процента. Даже небольшие суммы могут значительно вырасти за счет эффекта "снежного кома".
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicParametersSection;